/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { useTranslation } from 'react-i18next';
import { greys40 } from '@/components/common/palette';

export const Index: React.FC = ({ ...props }) => {
  const { t } = useTranslation();
  return (
    <a
      {...props}
      href="https://www.airwallex.com/terms/privacy-policy"
      target="_blank"
      css={css`
        color: ${greys40};
        font-size: 14px;
        font-weight: 400;
        &:hover {
          color: ${greys40};
          text-decoration-line: underline;
        }
      `}
      rel="noreferrer"
    >
      {t('term.link')}
    </a>
  );
};

export default Index;
